<script lang="ts">
	let className = '';
	export { className as class };
</script>

<div class="empty-icon-placeholder {className}" />

<style>
	.empty-icon-placeholder {
		width: 44px;
		height: 44px;
	}
</style>
